import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const ViewIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M21.5 12s-3.591 5.5-9.5 5.5S2.5 12 2.5 12 6.091 6.5 12 6.5s9.5 5.5 9.5 5.5Z"
            />
            <path stroke="currentColor" d="M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z" />
        </svg>
    </IconWrapper>
)
